<template>
  <v-card>
    <v-toolbar flat dark color="success">
      <v-spacer/>
      <v-toolbar-title>{{ editMode ? "Edit SMS Campaign" : "Add SMS Campaign" }}</v-toolbar-title>
      <v-spacer/>
    </v-toolbar>
    <v-card-text>
      <v-form class="mt-3" v-if="!loading">
        <v-autocomplete dense small-chips chips deletable-chips outlined label="Select Sender ID"
                        v-model="smsCampaignForm.senderId"
                        :items="senderIds" item-text="SenderId" item-value="id"/>
        <v-autocomplete dense small-chips chips deletable-chips outlined label="Level to Send Message"
                        v-model="smsCampaignForm.level"
                        :items="levels" item-text="name" item-value="value"/>
        <v-autocomplete return-object v-if="smsCampaignForm.level" dense chips deletable-chips outlined label="County"
                        :items="counties" item-text="county" item-value="county" @change="getConstituency"/>
        <v-autocomplete v-if="checkLevel('constituency')" dense chips deletable-chips outlined label="Constituency"
                        :items="constituencies" item-text="constituency" item-value="value" return-object
                        @change="getWard"/>
        <v-autocomplete v-if="checkLevel('ward')" dense chips deletable-chips return-object outlined label="Ward"
                        :items="wards" item-text="ward" item-value="value" @change="getPollingStation"/>
        <v-autocomplete v-if="checkLevel('polling')" dense chips deletable-chips outlined label="Polling Station"
                        v-model="smsCampaignForm.pollingstation"
                        :items="pollingstations" item-text="pollingstation" item-value="value"/>
        <v-textarea outlined v-model="smsCampaignForm.message" label="Enter Message"></v-textarea>

      </v-form>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="editMode?UpdateClientAdmin():RegisterClientAdmin()"
               :color="editMode?'blue':'green'" dark>
          {{ editMode ? 'Edit SMS Campaign' : 'Create SMS Campaign' }}
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import {getRequest, postRequest} from "@/api/apirepository";

export default {
  name: "smsCampaignForm",
  props: {
    selectedClientAdmin: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      wards: [],
      counties: [],
      senderIds: [],
      constituencies: [],
      pollingstations: [],
      levels: [
        {name: 'County', value: 'county'},
        {name: 'Constituency', value: 'constituency'},
        {name: 'Ward', value: 'ward'},
        {name: 'Polling Station', value: 'pollingstation'},
      ],
      smsCampaignForm: new Form({
        id: "",
        county: "",
        constituency: "",
        ward: "",
        pollingstation: "",
        level: "",
        message: "",
        userId: this.$store.state.user.id,
      }),
    }
  },
  computed: {
    editMode: {
      get: function () {
        return !!this.selectedClientAdmin;
      },
      set: function (newValue) {
        return !!this.selectedClientAdmin;
      }
    },
  },
  methods: {
    getCounties() {
      postRequest('counties').then(({data}) => {
        this.counties = data;
      }).catch(e => {
        console.log(e)
      })
    },
    getsenderIds() {
      getRequest('senderIds').then(({data}) => {
        this.senderIds = data;
      }).catch(e => {
        console.log(e)
      })
    },
    checkLevel(e) {
      if (e === 'constituency') {
        if (this.smsCampaignForm.level === 'county') {
          return false;
        } else if (this.smsCampaignForm.level === 'constituency' || this.smsCampaignForm.level === 'ward' || this.smsCampaignForm.level === 'pollingstation') {
          return true;
        }
      } else if (e === 'ward') {
        if (this.smsCampaignForm.level === 'county' || this.smsCampaignForm.level === 'constituency') {
          return false;
        } else if (this.smsCampaignForm.level === 'ward' || this.smsCampaignForm.level === 'pollingstation') {
          return true;
        }
      } else if (e === 'polling') {
        if (this.smsCampaignForm.level === 'county' || this.smsCampaignForm.level === 'constituency' || this.smsCampaignForm.level === 'ward') {
          return false;
        } else if (this.smsCampaignForm.level === 'pollingstation') {
          return true;
        }
      }
    },
    getConstituency(e) {
      this.smsCampaignForm.county = e.county;
      if (this.checkLevel('constituency')) {
        postRequest('constituencies', {
          county: e.county
        }).then(({data}) => {
          this.constituencies = data;
        }).catch(e => {
          console.log(e)
        })
      }
    },
    getWard(e) {
      this.smsCampaignForm.constituency = e.constituency;
      if (this.checkLevel('ward')) {
        postRequest('wards', {
              constituency: e.constituency,
              county: e.county,
            }
        ).then(({data}) => {
          this.wards = data;
        }).catch(e => {
          console.log(e)
        })
      }
    },
    getPollingStation(e) {
      this.smsCampaignForm.ward = e.ward;
      if (this.checkLevel('polling')) {
        postRequest('pollingstations', {

          ward: e.ward

        }).then(({data}) => {
          this.pollingstations = data;
        }).catch(e => {
          console.log(e)
        })
      }
    },
    RegisterClientAdmin() {
      postRequest('smsCampaign', this.smsCampaignForm).then(e => {
        this.$emit('campaignSuccess')
      }).catch(e => {
        swal.fire('error', 'Something went wrong', 'error')
      })
    }
  },
  created() {
    this.getCounties()
    this.getsenderIds()
  }
}
</script>

<style scoped>

</style>